<template>
  <div class="ops-page">
    <Modal
      v-model="modalAdd"
      title="新建版本"
      :mask-closable="false"
      :closable="false"
    >
      <Form :label-width="90">
        <FormItem label="平台" required>
          <Select v-model="form.platform" style="width: 100%" placeholder="请选择平台">
            <Option v-for="item in platformOptions" :value="item.value" :key="item.value">{{ item.label }}</Option>
          </Select>
        </FormItem>
        <FormItem label="版本号" required>
          <Input v-model="form.version" placeholder="如 3.2.1" clearable />
        </FormItem>
        <FormItem label="提示内容">
          <Input v-model="form.notice" type="textarea" :autosize="{minRows: 3}" placeholder="可选" />
        </FormItem>
      </Form>
      <div slot="footer">
        <Button @click="modalAdd = false; resetForm()">取消</Button>
        <Button type="primary" :loading="creating" @click="handleCreate">提交</Button>
      </div>
    </Modal>

    <div class="table-head">
      <span class="table-title">版本更新</span>
      <div>
        <Button type="primary" @click="openCreate">新建</Button>
        <Button style="margin-left: 8px" @click="getList">刷新</Button>
      </div>
    </div>
    <div ref="tableWrap" class="table-wrap">
      <Table :key="tableWidth" :columns="columns" :data="records">
      <template slot-scope="{ row }" slot="platform">
        <span>{{ platformLabel(row.platform) }}</span>
      </template>
      <template slot-scope="{ row }" slot="forced_updating">
        <span>{{ row.forced_updating === 1 ? '是' : '否' }}</span>
      </template>
      <template slot-scope="{ row }" slot="home_page_notice">
        <span>{{ row.home_page_notice === 1 ? '是' : '否' }}</span>
      </template>
      <template slot-scope="{ row }" slot="bag_notice">
        <span>{{ row.bag_notice === 1 ? '是' : '否' }}</span>
      </template>
      <template slot-scope="{ row }" slot="notice">
        <Tooltip transfer max-width="320">
          <div slot="content" class="notice-tip">{{ row.notice }}</div>
          <div class="ellipsis-4" v-html="formatNoticeHtml(row.notice)"></div>
        </Tooltip>
      </template>
      <template slot-scope="{ row }" slot="action">
        <Button size="small" @click="openCopyCreate(row)">复制新增</Button>
      </template>
    </Table>
    </div>
  </div>
</template>

<script>
import apis from '../../http/api'

const PLATFORM_OPTIONS = [
  { value: 0, label: 'AppStore' },
  { value: 1, label: '华为' },
  { value: 2, label: '小米' },
  { value: 3, label: 'OPPO' },
  { value: 4, label: 'VIVO' },
  { value: 5, label: '其他' },
  { value: 6, label: 'iPad' },
  { value: 7, label: '天猫' },
  { value: 8, label: '鸿蒙' },
]

const COL_RATIO_TOTAL = 11
const COL_RATIO_UNIT = 1
const COL_RATIO_NOTICE = 4
const ACTION_COL_WIDTH = 110

export default {
  name: 'OpsAppVersion',
  data() {
    return {
      platformOptions: PLATFORM_OPTIONS,
      records: [],
      modalAdd: false,
      creating: false,
      form: {
        platform: null,
        version: '',
        notice: '',
      },
      tableWidth: 0,
    }
  },
  computed: {
    columns() {
      const total = Math.max((this.tableWidth || 1100) - ACTION_COL_WIDTH, COL_RATIO_TOTAL)
      const unit = Math.floor(total / COL_RATIO_TOTAL)
      const unitW = unit * COL_RATIO_UNIT
      const noticeW = total - unitW * 7
      return [
        { title: '序号', key: 'index', width: unitW },
        { title: 'ID', key: 'id', width: unitW },
        { title: '平台', slot: 'platform', width: unitW },
        { title: '版本号', key: 'version', width: unitW },
        { title: '强制更新', slot: 'forced_updating', width: unitW },
        { title: '首页提示', slot: 'home_page_notice', width: unitW },
        { title: '背包提示', slot: 'bag_notice', width: unitW },
        { title: '提示内容', slot: 'notice', width: noticeW, align: 'left', className: 'notice-col' },
        { title: '操作', slot: 'action', width: ACTION_COL_WIDTH, align: 'center', fixed: 'right' },
      ]
    },
  },
  created() {
    this.getList()
  },
  mounted() {
    this.updateTableWidth()
    window.addEventListener('resize', this.updateTableWidth)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.updateTableWidth)
  },
  methods: {
    updateTableWidth() {
      this.$nextTick(() => {
        const el = this.$refs.tableWrap
        if (el && el.clientWidth) {
          this.tableWidth = el.clientWidth
        }
      })
    },
    platformLabel(value) {
      const item = PLATFORM_OPTIONS.find(p => p.value === value)
      return item ? item.label : value
    },
    formatNoticeHtml(text) {
      if (!text) {
        return ''
      }
      return String(text)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/\r\n|\r|\n/g, '<br>')
    },
    getList() {
      apis.app_version_list().then(res => {
        const { data, errCode, msg } = res
        if (errCode === 0) {
          this.records = (data && data.records) || []
        } else {
          this.$Message.error(msg || '获取版本列表失败')
        }
      }).catch(() => {
        this.$Message.error('获取版本列表失败')
      })
    },
    openCreate() {
      this.resetForm()
      this.modalAdd = true
    },
    openCopyCreate(row) {
      this.form = {
        platform: null,
        version: row.version || '',
        notice: row.notice || '',
      }
      this.modalAdd = true
    },
    resetForm() {
      this.form = {
        platform: null,
        version: '',
        notice: '',
      }
    },
    handleCreate() {
      if (this.creating) {
        return
      }
      if (this.form.platform === null || this.form.platform === undefined) {
        this.$Message.error('请选择平台')
        return
      }
      if (!this.form.version || !this.form.version.trim()) {
        this.$Message.error('请输入版本号')
        return
      }
      this.creating = true
      const payload = {
        platform: this.form.platform,
        version: this.form.version.trim(),
        notice: (this.form.notice || '').trim(),
      }
      apis.app_version_create(payload).then(res => {
        const { errCode, msg } = res
        if (errCode === 0) {
          this.$Message.success('新建成功')
          this.modalAdd = false
          this.resetForm()
          this.getList()
        } else {
          this.$Message.error(msg || '新建失败')
        }
      }).catch(() => {
        this.$Message.error('新建失败')
      }).finally(() => {
        this.creating = false
      })
    },
  },
}
</script>

<style scoped>
.ops-page {
  padding: 16px;
}

.table-head {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
}

.table-wrap {
  width: 100%;
}

.table-title {
  font-weight: bold;
  font-size: 16px;
}

.ellipsis-4 {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 4;
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: break-word;
  line-height: 1.4;
  max-height: calc(1.4em * 4);
  text-align: left;
  width: 100%;
}

.notice-tip {
  white-space: pre-wrap;
  word-break: break-word;
  max-width: 320px;
  text-align: left;
}
</style>

<style>
.ops-page .ivu-table td.notice-col .ivu-table-cell {
  text-align: left;
}
.ops-page .ivu-table td.notice-col .ivu-tooltip,
.ops-page .ivu-table td.notice-col .ivu-tooltip-rel {
  display: block;
  width: 100%;
  text-align: left;
}
</style>
